import { unwrapNodes, WithOverride } from '@udecode/plate';
import { Transforms } from 'slate';

import { ELEMENT_COL, ELEMENT_MULTI_COL } from './defaults';

export const withMultiCol: WithOverride<Record<string, unknown>> = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = (entry: any) => {
    const [node, path] = entry;
    if (node.type === ELEMENT_COL && !node.children.length) {
      Transforms.removeNodes(editor, { at: path });
      // early return since this node will no longer exists
      return;
    }
    if (node.type === ELEMENT_MULTI_COL && node.children.length === 1) {
      unwrapNodes(editor, { at: path, match: { type: ELEMENT_MULTI_COL } });
      unwrapNodes(editor, { at: path, match: { type: ELEMENT_COL } });
    }
    normalizeNode(entry);
  };

  return editor;
};
